import { DbLoadExternalInventoryByEan } from "../../../data/usecases/load-external-inventory-by-ean";
import { LoadExternalInventoryByEan } from "../../../domain/usecases/load-external-inventory-by-ean";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeAxiosHttpClient } from "../http";
import { makeMUApiUrl } from "../http/mu-api-url-factory";

export const makeDbLoadExternalInventoryByEan =
  (): LoadExternalInventoryByEan => {
    return new DbLoadExternalInventoryByEan(
      makeMUApiUrl("/product/inventory"),
      makeAxiosHttpClient()
    );
  };
